module.exports = __webpack_public_path__ + "img/asset.dacb31ad.png";